<template>
  <slot v-if="slotShow" :show="comShow"></slot>
</template>

<script lang="ts" setup>
  import { nextTick, watch, ref, reactive } from 'vue';

  const props = defineProps({
    show: {
      type: Boolean,
      default: false,
    },
  });
  const emit = defineEmits(['update:show']);

  const slotShow = ref(false);
  const comShow: any = reactive({ value: false });

  watch(
    () => props.show,
    (val) => {
      if (val) {
        // 组件 mounted
        slotShow.value = val;
        nextTick(() => {
          // 组件显示
          comShow.value = val;
        });
      } else {
        comShow.value = val;
      }
    }
  );

  watch(
    () => comShow.value,
    (val) => {
      emit('update:show', val);
    }
  );
</script>

<style lang="less" scoped></style>
